import React, { useState, memo } from 'react';
import { Pressable, View } from 'react-native';
import { rem } from 'design-system/values';
import Squircle from 'design-system/Squircle';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
const ToolbarButton = ({ size, active, icon, onPress, hitSlop, hasFilter }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const [isHovered, setIsHovered] = useState(false);
    return (<Pressable hitSlop={hitSlop} onPress={onPress} onHoverIn={() => setIsHovered(true)} onHoverOut={() => setIsHovered(false)}>
      <View>
        <Squircle width={rem(size)} height={rem(size)} color={isHovered || active ? colors.buttons.brandLight : colors.cards.onDark}>
          {React.cloneElement(icon, {
            alt: true,
            width: 20,
            height: 20,
            color: isHovered || active ? colors.text.textOnBrand : colors.elements.secondary,
        })}
        </Squircle>
        {!!hasFilter && <View style={styles.activeDot} pointerEvents="none"/>}
      </View>
    </Pressable>);
};
const styleSet = createStyleSheets((colors) => ({
    activeDot: {
        position: 'absolute',
        top: rem(2),
        right: rem(2),
        width: rem(7),
        height: rem(7),
        borderRadius: rem(7),
        backgroundColor: colors.elements.statusPositive,
    },
}));
export default memo(ToolbarButton);
